import { Box, DataList, Flex, Table } from '@volue/wave-react';
import React from 'react';

import type { SelectedGridElement } from '@/features/execute-calculation-set/overmind/calculation';

export const ExternalNetworkDetails: React.FunctionComponent<{
  externalNetworkInjection: SelectedGridElement<'ExternalNetworkInjection'>;
}> = ({ externalNetworkInjection }) => {
  return (
    <>
      {externalNetworkInjection.loadflow.type ===
        'ALL_LOAD_FLOW_SCENARIO_DETAILS' && (
        <Flex flow="column" gap={'spacingXs'}>
          <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
            {'Load Flow'}
          </Box>
          <Table aria-label="Load scenarios" highlightOnHover={false}>
            <Table.Header>
              <Table.ColumnHeader>{'Scenario'}</Table.ColumnHeader>
              <>
                {externalNetworkInjection.loadflow.details.map(scenario => (
                  <Table.ColumnHeader>
                    {scenario.scenarioName}
                  </Table.ColumnHeader>
                ))}
              </>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Flex
                  as={Table.Cell}
                  flow="column"
                  gap={'none'}
                  justifyContent="start"
                  alignItems="start"
                >
                  <Box>Voltage</Box>
                </Flex>
                <>
                  {externalNetworkInjection.loadflow.details.map(scenario => (
                    <Table.Cell>
                      {scenario.scenarioDetails.inputs.voltage.toString()}
                    </Table.Cell>
                  ))}
                </>
              </Table.Row>
            </Table.Body>
          </Table>
        </Flex>
      )}
      {externalNetworkInjection.shortCircuit.type ===
        'SHORT_CIRCUIT_DETAILS' && (
        <Flex flow="column" gap={'spacingXs'}>
          <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
            {'Short Circuit'}
          </Box>
          <Box css={{ color: '$colorBlack60', fontWeight: 'bolder' }}>
            {'Max'}
          </Box>
          <DataList className="mHxl" ratio={[3, 1]}>
            <Flex as={DataList.Row} main="space-between">
              <DataList.Label>{'Power Provision'}</DataList.Label>
              <Flex main={'end'} as={DataList.Value}>
                {externalNetworkInjection.shortCircuit.evaluatedResults.inputs.maxInitialSymShCCurrent.toString()}
              </Flex>
            </Flex>
            <Flex as={DataList.Row} main="space-between">
              <DataList.Label>{'R/X'}</DataList.Label>
              <Flex main={'end'} as={DataList.Value}>
                {
                  externalNetworkInjection.shortCircuit.evaluatedResults.inputs
                    .maxPowerFactor
                }
              </Flex>
            </Flex>
          </DataList>
          <Box css={{ color: '$colorBlack60', fontWeight: 'bolder' }}>
            {'Min'}
          </Box>
          <DataList className="mHxl" ratio={[3, 1]}>
            <Flex as={DataList.Row} main="space-between">
              <DataList.Label>{'Power Provision'}</DataList.Label>
              <Flex main={'end'} as={DataList.Value}>
                {externalNetworkInjection.shortCircuit.evaluatedResults.inputs.minInitialSymShCCurrent.toString()}
              </Flex>
            </Flex>
            <Flex as={DataList.Row} main="space-between">
              <DataList.Label>{'R/X'}</DataList.Label>
              <Flex main={'end'} as={DataList.Value}>
                {
                  externalNetworkInjection.shortCircuit.evaluatedResults.inputs
                    .minPowerFactor
                }
              </Flex>
            </Flex>
          </DataList>
        </Flex>
      )}
    </>
  );
};
